import MainImg from "../images/chooseUs/main.png";
import Box1 from "../images/chooseUs/icon1.png";
import Box2 from "../images/chooseUs/icon2.png";
import Box3 from "../images/chooseUs/icon3.png";

function ChooseUs() {
  return (
    <>
      <section className="choose-section">
        <div className="container">
          <div className="choose-container">
            <img
              className="choose-container__img"
              src={MainImg}
              alt="car_img"
            />
            <div className="text-container">
              <div className="text-container__left">
                <h4>Pourquoi nous choisir</h4>
                  <h2>Les meilleures offres que vous trouverez</h2>
                    <p>
                      Profitez des offres les plus avantageuses du marché grâce à nos tarifs imbattables.
                      Nous nous engageons à vous offrir le meilleur rapport qualité-prix, afin que vous puissiez
                      bénéficier de services et de véhicules de grande qualité sans dépasser votre budget.
                      Nos offres sont pensées pour vous garantir une expérience de location optimale.
                      Ne passez pas à côté de l’occasion de réaliser de belles économies.
                      </p>
                {/*<a href="#home">
                  Find Details &nbsp;
                  <i className="fa-solid fa-angle-right"></i>
                </a>*/}
              </div>
              <div className="text-container__right">
                <div className="text-container__right__box">
                  <img src={Box1} alt="car-img" />
                  <div className="text-container__right__box__text">
                    <h4>Route longue distance</h4>
                      <p>
                        Offrez-vous une expérience de conduite incomparable grâce à nos véhicules de qualité,
                        parfaits pour vos aventures et trajets longue distance.
                      </p>

                  </div>
                </div>
                <div className="text-container__right__box">
                  {" "}
                  <img src={Box2} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>Tarification tout compris</h4>
                      <p>
                        Bénéficiez de tout ce dont vous avez besoin dans un prix unique, clair et transparent
                        grâce à notre politique de tarification tout compris.
                      </p>
                  </div>
                </div>
                <div className="text-container__right__box">
                  {" "}
                  <img src={Box3} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>Aucun frais caché</h4>
                      <p>
                        Profitez d’une tranquillité totale grâce à notre politique sans frais cachés.
                        Nous privilégions une tarification claire, transparente et honnête.
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChooseUs;
